import React, { useEffect, useState } from "react";
import { useResources } from "../../utility/use-resources";
import styled, { createGlobalStyle } from "styled-components";
import Cookies from "js-cookie";

const Root = styled.a`
  width: 100%;
  background: ${({ $bgColor }) => $bgColor};
  padding: 15px 30px;
  display: flex;
  align-items: center;
  justify-content: center;
  .h6 {
    font-size: 18px;
    font-weight: 300;
    text-align: center;  
    color: ${({ $color }) => $color};
    @media screen and (max-width: 768px) {
      font-size: 16px;
    }
  }
  span {
    color: ${({ $color }) => $color};
    position: absolute;
    display: block;
    right: 15px;
    top: 50%;
    transform: translateY(-50%);
    cursor: pointer;
  }
  position: absolute;
  z-index: -1;
  transition: top .2s ease-out;
  /*top: ${({ $hide }) => $hide ? '0%' : '100%'};*/
  top: 100%;
`

const GlobalStyles = createGlobalStyle`
  body {padding-top: 138px;}
  @media screen and (max-width: 1200px) {
    body {padding-top: 118px;}
  }
`

const NewsBanner = (props) => {
  const [r] = useResources("general", "newsBanner");
  const [hide, setHide] = useState(false)

  useEffect(() => {
    if (hide) {
      Cookies.set('newsBannerClosed', true, { expires: 1 })
    }
  }, [hide])

  if (!r('visible') || Cookies.get('newsBannerClosed') || hide) return null
  const link = r('link.url')
  return (
    <Root as={link ? 'a' : 'div'} $hide={props.scrollDirection === 'down'} href={link} $bgColor={r('bgColor')} $color={r('color')}>
      <GlobalStyles />
      <p className="h6">{r('link.text')}</p>
      <span onClick={(e) => {
        e.preventDefault()
        setHide(true)
      }}><i className="fas fa-times"></i></span>
    </Root>
  );
};

export default NewsBanner;
